
























































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { TEntity } from '@/plugins/podolib/services/entities/Entity';
import { TAcquisition, TPatient } from '@/plugins/podolib/services/entities/EntityPatients';

import PatientAcquisitionExportationViewerPage from '@/components/patients/acquisition/exportation/PatientAcquisitionExportationViewerPage.vue';
import PatientAcquisitionExportationFrameDoctor from '@/components/patients/acquisition/exportation/frames/PatientAcquisitionExportationFrameDoctor.vue';
import PatientAcquisitionExportationFramePatient from '@/components/patients/acquisition/exportation/frames/PatientAcquisitionExportationFramePatient.vue';
import PatientAcquisitionExportationFrameTitle from '@/components/patients/acquisition/exportation/frames/PatientAcquisitionExportationFrameTitle.vue';
import PatientAcquisitionExportationFrameWalkingOverview from '@/components/patients/acquisition/exportation/frames/walking/overview/PatientAcquisitionExportationFrameWalkingOverview.vue';
import PatientAcquisitionExportationFrameWalkingContainerChartWalkingPhaseAverage from '@/components/patients/acquisition/exportation/frames/walking/PatientAcquisitionExportationFrameWalkingContainerChartWalkingPhaseAverage.vue';
import PatientAcquisitionExportationFrameWalkingContainerChartWalkingPhaseAverageDegraded from '@/components/patients/acquisition/exportation/frames/walking/PatientAcquisitionExportationFrameWalkingContainerChartWalkingPhaseAverageDegraded.vue';
import PatientAcquisitionExportationFrameWalkingMeta from '@/components/patients/acquisition/exportation/frames/walking/meta/PatientAcquisitionExportationFrameWalkingMeta.vue';
import PatientAcquisitionExportationFrameWalkingContainerChartGaitLine from '@/components/patients/acquisition/exportation/frames/walking/PatientAcquisitionExportationFrameWalkingContainerChartGaitLine.vue';
import PatientAcquisitionExportationFrameWalkingContainerChartRawStancePhaseAverageValue from '@/components/patients/acquisition/exportation/frames/walking/PatientAcquisitionExportationFrameWalkingContainerChartRawStancePhaseAverageValue.vue';
import PatientAcquisitionExportationFrameComments from '@/components/patients/acquisition/exportation/frames/PatientAcquisitionExportationFrameComments.vue';
import PatientAcquisitionExportationFrameWalkingContainerChartStancePhaseAverageRanges from '@/components/patients/acquisition/exportation/frames/walking/PatientAcquisitionExportationFrameWalkingContainerChartStancePhaseAverageRanges.vue';
import PatientAcquisitionExportationFrameWalkingContainerChartStancePhaseAverageStepSequence from '@/components/patients/acquisition/exportation/frames/walking/PatientAcquisitionExportationFrameWalkingContainerChartStancePhaseAverageStepSequence.vue';
import PatientAcquisitionExportationFrameRunningBanner from '@/components/patients/acquisition/exportation/frames/running/PatientAcquisitionExportationFrameRunningBanner.vue';
import PatientAcquisitionExportationFrameRunningContainerChartRunningPhaseAverage from '@/components/patients/acquisition/exportation/frames/running/PatientAcquisitionExportationFrameRunningContainerChartRunningPhaseAverage.vue';
import PatientAcquisitionExportationFrameRunningContainerChartRunningPhaseRunSteps from '@/components/patients/acquisition/exportation/frames/running/PatientAcquisitionExportationFrameRunningContainerChartRunningPhaseRunSteps.vue';
import PatientAcquisitionExportationFrameRunningContainerChartRunningPhaseAngles from '@/components/patients/acquisition/exportation/frames/running/PatientAcquisitionExportationFrameRunningContainerChartRunningPhaseAngles.vue';
import PatientAcquisitionExportationFrameRunningContainerChartStrikePattern from '@/components/patients/acquisition/exportation/frames/running/PatientAcquisitionExportationFrameRunningContainerChartStrikePattern.vue';
import PatientAcquisitionExportationFrameWalkingContainerChartRawRatioPropulsion from '@/components/patients/acquisition/exportation/frames/walking/PatientAcquisitionExportationFrameWalkingContainerChartRawRatioPropulsion.vue';
import PatientAcquisitionExportationFrameWalkingContainerChartRawPronationSupinationAngles from '@/components/patients/acquisition/exportation/frames/walking/PatientAcquisitionExportationFrameWalkingContainerChartRawPronationSupinationAngles.vue';
import PatientAcquisitionExportationFrameWalkingContainerChartRawFootProgression from '@/components/patients/acquisition/exportation/frames/walking/PatientAcquisitionExportationFrameWalkingContainerChartRawFootProgression.vue';
import PatientAcquisitionExportationFrameWalkingContainerChartRawClearanceSteppage from '@/components/patients/acquisition/exportation/frames/walking/PatientAcquisitionExportationFrameWalkingContainerChartRawClearanceSteppage.vue';

@Component({
  components: {
    PatientAcquisitionExportationFrameWalkingContainerChartRawClearanceSteppage,
    PatientAcquisitionExportationFrameWalkingContainerChartRawFootProgression,
    PatientAcquisitionExportationFrameWalkingContainerChartRawPronationSupinationAngles,
    PatientAcquisitionExportationFrameWalkingContainerChartRawRatioPropulsion,
    PatientAcquisitionExportationFrameRunningContainerChartRunningPhaseAngles,
    PatientAcquisitionExportationFrameRunningContainerChartStrikePattern,
    PatientAcquisitionExportationFrameRunningContainerChartRunningPhaseRunSteps,
    PatientAcquisitionExportationFrameRunningContainerChartRunningPhaseAverage,
    PatientAcquisitionExportationFrameRunningBanner,
    PatientAcquisitionExportationFrameWalkingContainerChartStancePhaseAverageStepSequence,
    PatientAcquisitionExportationFrameWalkingContainerChartStancePhaseAverageRanges,
    PatientAcquisitionExportationFrameComments,
    PatientAcquisitionExportationFrameWalkingContainerChartRawStancePhaseAverageValue,
    PatientAcquisitionExportationFrameWalkingContainerChartGaitLine,
    PatientAcquisitionExportationFrameWalkingMeta,
    PatientAcquisitionExportationViewerPage,
    PatientAcquisitionExportationFrameDoctor,
    PatientAcquisitionExportationFramePatient,
    PatientAcquisitionExportationFrameTitle,
    PatientAcquisitionExportationFrameWalkingContainerChartWalkingPhaseAverage,
    PatientAcquisitionExportationFrameWalkingContainerChartWalkingPhaseAverageDegraded,
    PatientAcquisitionExportationFrameWalkingOverview,
  },
})
export default class PatientAcquisitionExportationViewer extends Vue {
  @Prop({ required: true }) private dialog!: boolean;
  @Prop({ required: true }) private patient!: TEntity<TPatient>;
  @Prop({ required: true }) private acquisition!: TEntity<TAcquisition>;
  @Prop(Boolean) private pending!: boolean;
  @Prop(Boolean) private mode!: 'normal' | 'advanced';
  @Prop(Boolean) private hideEmail!: boolean;
  @Prop(Boolean) private hidePhone!: boolean;
  @Prop(Boolean) private selectedOffice!: string;

  pageTotal = 0;

  comment = '';
  actions = '';

  updated() {
    this.pageTotal = (this.$refs.iframe as any).exportApp.$children.filter((x: any) => x.type === 'page').length;
    // console.log(`PDF updated (-> ${this.pageTotal})`);
  }

  get modeIsAdvanced() {
    return this.mode === 'advanced';
  }

  get isWalking() {
    return this.acquisition?.analysisType === 'podosmart';
  }

  get isDegradedActivity() {
    return this.acquisition?.analysisType === 'podosmart' && this.$pdc.helper?.isDegradedActivity(this.acquisition);
  }

  @Watch('dialog')
  onDialogChanged() {
    if (!this.dialog) {
      this.comment = '';
      this.actions = '';
    }
  }

  /**
   * Print iframe
   */
  public print() {
    // (this.$refs.iframe as any).$el.contentWindow.print();
    (this.$refs.iframe as any).exportApp.print();
  }
}
